module.exports = __webpack_public_path__ + "static/media/team-marcelo.ca6269a7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/team-marcelo.jpg
 ** module id = 448
 ** module chunks = 0
 **/